module.exports = __webpack_public_path__ + "img/ark.e7719deb.svg";